<nz-modal [nzMaskClosable]="false" [(nzVisible)]="isVisible" nzTitle="Multiple Paging Board" [nzWidth]="1500" [nzFooter]="modalDateFooter" (nzOnCancel)="handleCancel()">
  <ng-container *nzModalContent>
    <div class="flex gap-5 mb-4">
      <nz-range-picker class="w-full" [(ngModel)]="dateRanges" (ngModelChange)="onChangeDatePicker($event)"></nz-range-picker>
      <button nz-button nzType="primary" [nzLoading]="pdfLoading" [disabled]="bookings.length < 1" (click)="loadPagingBoard()">Generate All</button>
      <button nz-button nzType="primary" [disabled]="!pagingBoardPdf || isEditData" (click)="pagingBoardAction('preview')">Preview</button>
      <button nz-button nzType="primary" [disabled]="!pagingBoardPdf || isEditData" (click)="pagingBoardAction('print')">Print</button>
      <button nz-button nzType="primary" [disabled]="!pagingBoardPdf || isEditData" (click)="pagingBoardAction('download')">Download</button>
    </div>
    <section>
          <div [ngClass]="!loading ? 'block' : 'hidden'" class="table-card">
            <div class="table-obj">
              <nz-table
                #multiplePagingBoardTable [nzData]="bookings" [nzFrontPagination]="false" nzTableLayout="fixed" [nzScroll]="{ x: 'auto' }"
                nzOuterBordered class="table-wSpace-nowrap"
              >
                <thead>
                  <tr>
                    <th>Tour ID</th>
                    <th>Customer Name</th>
                    <th>Vehicle Category</th>
                    <th>Arrival Date</th>
                    <th>Arrival Time</th>
                    <th>Arrival Flight Number</th>
                    <th>Drop Off Location</th>
                    <th>Number of Pax</th>
                    <th>Contact Number</th>
                    <th>Agent Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of multiplePagingBoardTable.data; index as i" class="align-baseline">
                    <td>{{ data?.refNo }}</td>
                    <td>{{ data?.customer }}</td>
                    <td>{{ data?.vehicleCategory }}</td>
                    <td>{{ data?.date | date: 'dd-MM-y' }}</td>
                    <td>{{ data?.time | date: 'hh:mm:a' }}</td>
                    <td>{{ data?.flight ? data.flight : '-'}}</td>
                    <td>{{ data?.dropLocation ? data.dropLocation : '-'}}</td>
                    <td>{{ data?.numOfPax ? data.numOfPax : '-'}}</td>
                    <td>{{ data?.customerNumber ? data.customerNumber : '-'}}</td>
                    <td>{{ data?.agent ? data.agent : '-'}}</td>
                    <td>
                      <button class="mr-3 outline-button" nz-button nzType="default" (click)="editDetails(data, i)">Edit</button>
                      <!--              <button class="outline-button" nz-button nzType="default">Generate</button>-->
                    </td>
                  </tr>
                </tbody>
              </nz-table>
            </div>
          </div>
          <div [ngClass]="loading ? 'block' : 'hidden'">
            <app-table-skeleton-template [columnData]="skeletonTableColumns" [showAdvanceSearch]="false"></app-table-skeleton-template>
          </div>
    </section>

  </ng-container>

  <ng-template #modalDateFooter>

  </ng-template>

</nz-modal>

<nz-modal
  [(nzVisible)]="visibleEditFormPopup"
  [nzTitle]="modalTitleOfRental"
  [nzContent]="modalContentOfRental"
  [nzFooter]="modalFooterOfRental"
  (nzOnCancel)="cancelPagingBoardEditModal()"
  nzClosable="false"
>
  <ng-template #modalTitleOfRental>
    <div class="flex justify-between items-center my-4">
      <h4>Paging Board Edit</h4>
    </div>
  </ng-template>

  <ng-template #modalContentOfRental>
    <div *ngIf="!loading">
      <div class="my-4">
        <form nz-form [formGroup]="pagingBoardForm" [nzLayout]="'vertical'">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="customer" nzRequired>Customer Name</nz-form-label>
            <nz-form-control [nzErrorTip]="customerNameError">
              <input nz-input class="w-full" type="text" formControlName="customer" placeholder="Enter Name"/>
            </nz-form-control>
            <ng-template #customerNameError>
              <span *ngIf="pagingBoardErrors?.customer?.required">Please enter customer name. </span>
              <span *ngIf="pagingBoardErrors?.customer?.wordLimit">Only allowed 2 words with 15 characters. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="vehicleCategory">Vehicle Category</nz-form-label>
            <nz-form-control [nzErrorTip]="vehicleCategoryError">
              <input nz-input class="w-full" type="text" formControlName="vehicleCategory" placeholder="Enter Category"/>
            </nz-form-control>
            <ng-template #vehicleCategoryError></ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="date" nzRequired>Arrival Date</nz-form-label>
            <nz-form-control [nzErrorTip]="dateError">
              <nz-date-picker class="w-full" formControlName="date"></nz-date-picker>
            </nz-form-control>
            <ng-template #dateError>
              <span *ngIf="pagingBoardErrors?.date?.required">Please select date. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="time" nzRequired>Arrival Time</nz-form-label>
            <nz-form-control [nzErrorTip]="timeError">
              <nz-time-picker nzPlaceHolder="Select Time" class="w-full" formControlName="time"   [nzFormat]="'HH:mm'"></nz-time-picker>
            </nz-form-control>
            <ng-template #timeError>
              <span *ngIf="pagingBoardErrors?.time?.required">Please select time. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="flight" nzRequired>Arrival Flight Number</nz-form-label>
            <nz-form-control [nzErrorTip]="flightError">
              <input nz-input class="w-full" type="text" formControlName="flight" placeholder="Enter Flight"/>
            </nz-form-control>
            <ng-template #flightError>
              <span *ngIf="pagingBoardErrors?.flight?.required">Please enter flight name. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="dropLocation">Drop Off Location</nz-form-label>
            <nz-form-control [nzErrorTip]="dropLocationError">
              <input nz-input class="w-full" type="text" formControlName="dropLocation" placeholder="Enter Location"/>
            </nz-form-control>
            <ng-template #dropLocationError>
              <span *ngIf="pagingBoardErrors?.dropLocation?.required">Please enter location. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="numOfPax">Number of Pax</nz-form-label>
            <nz-form-control [nzErrorTip]="nuOfPaxError">
              <input nz-input class="w-full" type="number" [min]="0" formControlName="numOfPax" placeholder="Enter Number Of Pax"/>
            </nz-form-control>
            <ng-template #nuOfPaxError>
              <span *ngIf="pagingBoardErrors?.numOfPax?.required">Please enter count. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="customerNumber" nzRequired>Contact Number</nz-form-label>
            <nz-form-control [nzErrorTip]="customerNumberError">
              <input nz-input class="w-full" type="text" formControlName="customerNumber" placeholder="Enter Number"/>
            </nz-form-control>
            <ng-template #customerNumberError>
              <span *ngIf="pagingBoardErrors?.customerNumber?.required">Please enter number. </span>
              <span *ngIf="pagingBoardErrors?.customerNumber?.maxlength"> Maximum length is 15 characters.</span>
              <span *ngIf="pagingBoardErrors?.customerNumber?.pattern">Only allowed numbers, please avoid adding special characters or letters.</span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="agent">Agent Name</nz-form-label>
            <nz-form-control [nzErrorTip]="agentError">
              <input nz-input class="w-full" type="text" formControlName="agent" placeholder="Enter Agent Name"/>
            </nz-form-control>
            <ng-template #agentError></ng-template>
          </nz-form-item>
        </form>
      </div>
    </div>
  </ng-template>

  <ng-template #modalFooterOfRental>
    <div class="flex max-[400px]:flex-col justify-between items-center gap-2 my-4">
      <div class="flex gap-2">
        <button nz-button nzType="default" class="max-[400px]:order-last max-[400px]:w-full cancel-btn" (click)="cancelPagingBoardEditModal()">Cancel</button>
        <button nz-button nzType="default" class="outline-button" (click)="saveUpdatedData()">Save</button>
      </div>
    </div>
  </ng-template>
</nz-modal>

